export default __webpack_public_path__ + "static/media/012-lawnmower.1329c508.svg";